import { Injectable } from '@angular/core';
import { MenuItem } from '@arc/aureus';
import { Subject } from 'rxjs';

@Injectable()
export class BreadcrumbService {
  private itemsSource = new Subject<MenuItem[]>();

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: MenuItem[]): void {
    this.itemsSource.next(items);
  }
}
